/**************************************************
 * Nombre:       Seccion_Home
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Home_Portada from "./Componentes/Home_Portada";
import Home_Propuesta_Anuncios from "./Componentes/Home_Propuesta_Anuncios";
import Home_Encontraras from "./Componentes/Home_Encontraras";
import Home_Sistema from "./Componentes/Home_Sistema";
import Home_Capacitaciones from "./Componentes/Home_Capacitaciones";
import Home_Historias from "./Componentes/Home_Historias";
import Home_Galeria from "./Componentes/Home_Galeria";
import Home_Calendario from "./Componentes/Home_Calendario";
import {useResponsive} from "../../Modulo_Responsive/Hooks/useResponsive";
import Home_Mixlrs from "./Componentes/Home_Mixlrs";

const Seccion_Home = () => {
    const {sCell} = useResponsive()
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: sCell ? 1 : 0}}>
                <Home_Portada/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 6}}>
                <Home_Propuesta_Anuncios/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 6, zIndex: 1}}>
                <Home_Encontraras/>
            </Grid>

            <Grid id={'sistema'} container size={{xs: 12, sm: 12, md: 12}}
                  sx={{justifyContent: 'flex-start', zIndex: 1}}>
                <Home_Sistema/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', zIndex: 2, mt: 0}}>
                <Home_Capacitaciones/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}}
                  sx={{justifyContent: 'flex-start', zIndex: 2, mt: sCell ? 0 : 8}}>
                <Home_Mixlrs/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}}
                  sx={{justifyContent: 'flex-start', zIndex: 2, mt: sCell ? 0 : 8}}>
                <Home_Historias/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', zIndex: 2, mt: 16}}>
                <Home_Galeria/>
            </Grid>

            <Grid id={'calendario'} container size={{xs: 12, sm: 12, md: 12}}
                  sx={{justifyContent: 'flex-start', zIndex: 2, mt: sCell ? 0 : 8}}>
                <Home_Calendario/>
            </Grid>

        </Grid>
    )

}
export default Seccion_Home